import config from '../config';

let LAST_NOTIFICATION: undefined | { title: string, data: number };

const NOTIF_TAG = 'cogneed-app-notification';

export default async function sendNotification(title: string, options?: any) {
  const registration = await navigator.serviceWorker.ready;
  if (LAST_NOTIFICATION && LAST_NOTIFICATION.title === title && LAST_NOTIFICATION.data > Date.now() - config.NotificationCoolDown) {
    return;
  }

  const notifications = await registration.getNotifications();
  const notification = notifications.find((current) => current.tag === NOTIF_TAG);
  if (notification) {
    notification.close();
  }

  registration.showNotification(title, {
    icon: 'logo192.png',
    silent: true,
    tag: NOTIF_TAG,
    ...options,
  });
  LAST_NOTIFICATION = { title, data: Date.now() };
}
